'use client';

import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import { useRouter } from 'next/navigation';
import { useContext, useState } from 'react';

import type { CamelCasePromotion } from '@/apis/server/new-car/v1/promotions';
import {
  PromotionDetailsModal,
} from '@/app/_components/page_content/new-car-promo/promotion-details-modal';
import { CoverLinkList } from '@/components/cover-link-list';
import { InfoContext } from '@/context/info';
import { createTimestampUid } from '@/utils/id';
import { joinSgcmMsSite } from '@/utils/url/join/public';

import { featuredMerchantsAds } from './configs';
import { DY_ITEMS_COUNT } from './constants';
import { Item } from './item';
import type { Component } from './types';

export const DyItems: Component = () => {
  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();
  const {
    tacticalAds,
    dyArticles,
    carDetail,
  } = useContext(InfoContext);
  const router = useRouter();
  const [randomFeaturedMerchantsIndex] = useState(
    Math.floor(Math.random() * featuredMerchantsAds(isDesktopMode).length),
  );

  const [
    activePromotionDetailsItem,
    setActivePromotionDetailsItem,
  ] = useState<CamelCasePromotion | null>(null);
  const [
    isPromotionDetailsModalOpen,
    setIsPromotionDetailsModalOpen,
  ] = useState(false);

  const [
    promotionDetailsModalKey,
    setPromotionDetailsModalKey,
  ] = useState(createTimestampUid);

  const handlePromotionClick = (promo: CamelCasePromotion) => () => {
    if (isDesktopMode) {
      setActivePromotionDetailsItem(promo);
      setIsPromotionDetailsModalOpen(true);
    } else {
      const competitorCar = promo.competitorCars?.find(
        carId => carId === carDetail.id.toString(),
      );

      router.push(`${joinSgcmMsSite(`/new-cars/info/${promo.carId}/${promo.slug}/promo${competitorCar ? `?competitor_car=${promo.competitorCars?.join(',')}` : ''}#${promo.id}`)}`);
    }
  };

  return (
    <>
      <CoverLinkList>
        {[
          ...tacticalAds,
          featuredMerchantsAds(isDesktopMode)[randomFeaturedMerchantsIndex],
          ...dyArticles,
        ].map((item) => {
          if (item instanceof Object && 'image' in item) {
            return (
              <Item
                key={item.id}
                thumbnailUrl={item.image}
                title={`Latest ${item.make ?? 'cars'} Promotion by ${item.dealer.name}`}
                onClick={handlePromotionClick(item)} />
            );
          }

          if (item instanceof Object && 'title' in item) {
            return (
              <Item
                key={item.title}
                href={item.link}
                thumbnailUrl={item.img}
                title={item.title} />
            );
          }

          return (
            <Item
              key={item.sku}
              href={item.productData.url}
              thumbnailUrl={
                item.productData.image_url ?? item.productData.image_url_2
              }
              title={item.productData.name} />
          );
        }).slice(0, DY_ITEMS_COUNT)}
      </CoverLinkList>
      <PromotionDetailsModal
        key={promotionDetailsModalKey}
        isOpen={isPromotionDetailsModalOpen}
        promotion={activePromotionDetailsItem}
        onClose={() => {
          setIsPromotionDetailsModalOpen(false);
          window.history.pushState(null, '', ' ');
        }}
        onExit={() => {
          setPromotionDetailsModalKey(createTimestampUid());
        }} />
    </>
  );
};
